import Quill from 'quill';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BlockEmbed: any = Quill.import('blots/block/embed');

export type TableBlotValue = {
  rows: number;
  cols: number;
  html?: string;
};

function buildTableHtml(rows: number, cols: number): string {
  const safeRows = Math.min(20, Math.max(1, rows));
  const safeCols = Math.min(10, Math.max(1, cols));
  const headCells = Array.from({ length: safeCols }, (_, i) => `<th>Coluna ${i + 1}</th>`).join('');
  const bodyRows = Array.from({ length: Math.max(0, safeRows - 1) }, () => {
    const cells = Array.from({ length: safeCols }, () => '<td><br></td>').join('');
    return `<tr>${cells}</tr>`;
  }).join('');
  return `<thead><tr>${headCells}</tr></thead><tbody>${bodyRows}</tbody>`;
}

function enableCellEditing(table: HTMLTableElement): void {
  table.querySelectorAll('th, td').forEach((cell) => {
    cell.setAttribute('contenteditable', 'true');
  });
}

export class TableBlot extends BlockEmbed {
  static blotName = 'doctable';
  static tagName = 'DIV';
  static className = 'ql-doc-table-wrap';

  static create(value: TableBlotValue | string): HTMLElement {
    const node = super.create() as HTMLElement;
    node.setAttribute('contenteditable', 'false');

    const table = document.createElement('table');
    table.className = 'ql-doc-table';

    if (typeof value === 'string') {
      table.innerHTML = value;
    } else if (value?.html) {
      table.innerHTML = value.html;
    } else {
      table.innerHTML = buildTableHtml(value?.rows ?? 3, value?.cols ?? 3);
    }

    enableCellEditing(table);
    node.appendChild(table);

    node.addEventListener('mousedown', (event) => {
      const target = event.target as HTMLElement;
      if (target.closest('th, td')) {
        event.stopPropagation();
      }
    });

    return node;
  }

  static value(node: HTMLElement): TableBlotValue {
    const table = node.querySelector('table');
    const rows = table?.rows.length ?? 1;
    const cols = table?.rows[0]?.cells.length ?? 1;
    return {
      rows,
      cols,
      html: table?.innerHTML || '',
    };
  }
}

export function createEmptyTableValue(rows: number, cols: number): TableBlotValue {
  return {
    rows,
    cols,
    html: buildTableHtml(rows, cols),
  };
}
